import Loader from "components/Loader";
import { useModal } from "context/hooks/useModal";

const RenderURL = ({ url }) => {
  const { hideModal } = useModal();
  
  return (
    <div className="max-h-[90vh] overflow-y-auto">
      <button
        className="rounded-full border border-black w-6 h-6"
        onClick={hideModal}
      >
        X
      </button>
      <div className="w-full" id="iframe-loader">
        <Loader open type="block" />
      </div>

      <iframe
        src={url}
        className="w-full h-[calc(90vh-30px)]"
        onLoad={() => {
          const loaderEle = document.getElementById("iframe-loader");
          loaderEle.style.display = "none";
        }}
      />
    </div>
  );
};

export default RenderURL;
